import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ToolbarIcon from 'components/ToolbarIcon';
import Dropdown from './Dropdown';

const ToolbarDropdownMenu = forwardRef(({ options: groups, onOptionClick}, ref) => {
  return (
    <Dropdown ref={ref}>
      {groups && groups.map((options, groupIndex) => (
        <Group key={`dropdownMenuGroup${groupIndex}`}>
          {options && options.map((option) => (
            <Item key={option.key} onClick={() => onOptionClick(option)}>
              {option.icon && <ToolbarIcon name={option.icon} />}
              <Label>{option.label}</Label>
              {option.description && <Description>{option.description}</Description>}
            </Item>
          ))}
        </Group>
      ))}
    </Dropdown>
  );
});

export default ToolbarDropdownMenu;

ToolbarDropdownMenu.propTypes = {
  onOptionClick: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        icon: PropTypes.string,
        description: PropTypes.string
      }).isRequired
    )
  )
}

ToolbarDropdownMenu.defaultProps = {
  option: [],
  onOptionClick: () => ({}),
}

const Group = styled.ul`
  all: unset;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  width: 100%;
  min-width: 320px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--lizzy-black-10);
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
`;

const Item = styled.li`
  all: unset;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-basis: 100%;
  padding: 2px 8px 2px 6px;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: var(--lizzy-black-5);
  }

  i {
    font-size: 16px;
    padding: 6px;
    margin-right: 6px;
  }
`;

const Label = styled.span``;
const Description = styled.span`
  margin-left: auto;
  font-size: 13px;
  color: var(--lizzy-black-35);
`;